import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator, StyleSheet, TouchableOpacity } from 'react-native';

import { HeaderWrapper } from './HeaderWrapper';
import { Box, Text } from '../Restyle';

type FloatingHeaderProps = {
  disabled?: boolean;
  isLoading?: boolean;
  onSave?: () => void;
  simple?: boolean;
  title: string;
  saveButtonTitle?: string;
  hideBorder?: boolean;
  hideCancel?: boolean;
  disablePadding?: boolean;
  onCancel?: () => void;
};

export const FloatingHeader: React.FC<FloatingHeaderProps> = ({
  simple,
  disabled,
  isLoading,
  onSave,
  title,
  saveButtonTitle,
  hideBorder,
  hideCancel,
  disablePadding,
  onCancel,
}) => {
  const navigation = useNavigation();
  const { t } = useTranslation();
  // saveButtonTitle can legitimately be ''; ?? would skip the 'save' fallback
  const saveLabel = saveButtonTitle ? saveButtonTitle : t('shared:save'); // NOSONAR

  const renderHeader = (
    <Box flexDirection='row' justifyContent='space-between'>
      {!hideCancel && (
        <Box style={styles.back}>
          <TouchableOpacity
            onPress={onCancel ?? (() => navigation.goBack())}
            accessibilityLabel={t('shared:cancel')}>
            <Text color='greenSecondary'>{t('shared:cancel')}</Text>
          </TouchableOpacity>
        </Box>
      )}

      <Box flex={1}>
        <Text variant='labelEmphasized' textAlign='center'>
          {title}
        </Text>
      </Box>

      {onSave && (
        <Box style={styles.save}>
          {(() => {
            if (isLoading) return <ActivityIndicator size='small' />;
            if (disabled) {
              return <Text color='grey04'>{saveLabel}</Text>;
            }
            return (
              <TouchableOpacity
                onPress={() => onSave()}
                accessibilityLabel={saveLabel}>
                <Text color='greenSecondary'>{saveLabel}</Text>
              </TouchableOpacity>
            );
          })()}
        </Box>
      )}
    </Box>
  );
  if (hideBorder)
    return (
      <Box paddingHorizontal={disablePadding ? undefined : 'm'}>
        {renderHeader}
      </Box>
    );
  return <HeaderWrapper simple={simple}>{renderHeader}</HeaderWrapper>;
};

const styles = StyleSheet.create({
  back: {
    zIndex: 99,
    position: 'absolute',
    left: 0,
  },
  save: {
    zIndex: 99,
    position: 'absolute',
    right: 0,
  },
});
